//jqueryFree
export default function () {
	document.querySelectorAll('.page-locations').forEach((rootEl) => {
		rootEl.querySelectorAll('svg > path').forEach((el) => {
			el.addEventListener('click', () => {
				var regionId = 'region-' + el.dataset.region;
				var region = document.getElementById(regionId);

				if (regionId === 'region-praha') {
					window.location.href = region.querySelector('a').href;
					return;
				}
				region.scrollIntoView();
			});
		});

		rootEl.querySelectorAll('button').forEach((el) => {
			el.addEventListener('click', () => {
				var citiesClassList = el.parentElement.parentElement.parentElement.nextElementSibling.classList;
				citiesClassList.toggle('hidden');

				el.textContent = citiesClassList.contains('hidden')
					? 'zobrazit vše'
					: 'skrýt vše';
			});
		});
	});
}
